const ISSUER_LABEL = 'Issuer'
const APPLICANT_LABEL = 'Applicant'

/**
 * Role is expected to be a string, but due to the amount of any types passed around the codebase, I've needed to force role ?? '' as a parameter in some places.
 **/
export const getRoleLabel = (options: Map<string, any>, role: string, fallback?: string): string => {
  if (!role) {
    return fallback ?? ''
  }

  let label = options.get(role) ?? fallback ?? role ?? ''

  if (label === ISSUER_LABEL) {
    label = APPLICANT_LABEL
  }

  return label
}
